interface SvgProps {
  color?: string;
  width?: string;
  height?: string;
}

const MoonIcon = ({
  color = "white",
  width = "13",
  height = "13",
}: SvgProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 15.1C20.2 15.4 19.4 15.5 18.5 15.5C14.3 15.5 11 12.2 11 8C11 6.7 11.3 5.5 11.8 4.4C12 3.9 11.6 3.4 11 3.5C6.8 4.2 3.5 8 3.5 12.3C3.5 16.9 7.3 20.5 12 20.5C15.6 20.5 18.7 18.2 20 15.1C20.2 14.6 20.6 14.8 21 15.1Z"
        fill={color}
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MoonIcon;
